
export type PerformanceConfig = {
  bootPreload: {
    commonTextures: boolean;
    initialVillageOnly: boolean;
    savedHouseOnly: boolean;
  };
  npc: {
    cameraCullPadding: number;
    offscreenUpdateIntervalMs: number;
    onscreenUpdateIntervalMs: number;
    hideOffscreenSprites: boolean;
  };
  telemetry: {
    enabled: boolean;
    sampleWindowSeconds: number;
  };
};

const DEFAULTS: PerformanceConfig = {
  bootPreload: {
    commonTextures: true,
    initialVillageOnly: true,
    savedHouseOnly: true,
  },
  npc: {
    cameraCullPadding: 220,
    offscreenUpdateIntervalMs: 220,
    onscreenUpdateIntervalMs: 0,
    hideOffscreenSprites: true,
  },
  telemetry: {
    enabled: true,
    sampleWindowSeconds: 10,
  },
};

let cached: PerformanceConfig | null = null;

export async function loadPerformanceConfig(): Promise<PerformanceConfig> {
  if (cached) return cached;
  try {
    const response = await fetch('/config/performance.json', { cache: 'no-store' });
    if (!response.ok) throw new Error('performance.json load failed');
    const data = await response.json() as Partial<PerformanceConfig>;
    cached = {
      bootPreload: { ...DEFAULTS.bootPreload, ...(data.bootPreload ?? {}) },
      npc: { ...DEFAULTS.npc, ...(data.npc ?? {}) },
      telemetry: { ...DEFAULTS.telemetry, ...(data.telemetry ?? {}) },
    };
    return cached;
  } catch {
    cached = DEFAULTS;
    return cached;
  }
}
